import React from 'react';
import ReactDOM from 'react-dom/client';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { FiX } from 'react-icons/fi';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Toaster 
      position="bottom-right"
      containerStyle={{
        bottom: 20,
        right: 20,
      }}
      toastOptions={{
        duration: 3000,
        style: {
          background: '#1a1a1a',
          color: '#fff',
          border: '1px solid #333',
          padding: '12px 40px 12px 16px',
          maxWidth: '400px'
        },
        success: {
          iconTheme: {
            primary: '#c9a227',
            secondary: '#000'
          }
        },
        error: {
          iconTheme: {
            primary: '#e74c3c',
            secondary: '#fff'
          }
        }
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== 'loading' && (
                <button
                  onClick={() => toast.dismiss(t.id)}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    color: '#888',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <FiX size={16} />
                </button>
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
    <App />
  </React.StrictMode>
);